import React from 'react';
import { usePermission } from '../contexts/PermissionContext';

/**
 * 權限標籤列（專案卡片、年度供應商資料共用）
 * 🔒 圖示＋彩色標籤，顏色沿用「權限標籤管理」的設定；擁有其中任一標籤的使用者可存取該資源
 * @param {Object} props
 * @param {string[]} props.tags - 權限標籤名稱
 * @param {string} props.resourceLabel - 資源名稱（用於提示文字），例如「專案」「此資料」
 * @param {string} props.className - 額外的 CSS 類別
 */
function AccessTagList({ tags = [], resourceLabel = '此資源', className = '' }) {
  const { getTagInfo } = usePermission();
  if (!tags.length) return null;

  return (
    <div
      className={`flex items-start text-sm text-gray-600 ${className}`}
      title={`權限標籤：擁有其中任一標籤的使用者可存取${resourceLabel}`}
    >
      <svg
        className="w-4 h-4 mr-2 mt-0.5 flex-shrink-0"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
        />
      </svg>
      <div className="flex flex-wrap gap-1">
        {tags.map((tagName) => (
          <span
            key={tagName}
            className="px-2 py-0.5 rounded-full text-xs text-white font-medium"
            style={{ backgroundColor: getTagInfo(tagName)?.color || '#6B7280' }}
          >
            {tagName}
          </span>
        ))}
      </div>
    </div>
  );
}

export default AccessTagList;
